import { dateStringToDateTime, formatInternalDate } from '~/lib/DateTime';
import TextInput from '~/components/TextInput';

const DateInput = ({
    className,
    placeholder,
    autoFocus,
    value,
    onChange,
    ...params
}) => {
    return (
        <TextInput
            className={className}
            placeholder={placeholder}
            type="date"
            autoFocus={autoFocus}
            value={formatInternalDate(value)}
            onChange={newValue => {
                onChange(dateStringToDateTime(newValue))
            }}
            {...params}
        />
    );
};

export default DateInput;
